import interrupt from "../interrupt";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-transition/src/selection/interrupt.js
// module id = ../../../../d3-transition/src/selection/interrupt.js
// module chunks = 3